import { request } from '../request'


/**
 * 获取会员名字和手机号码
 */
export function getAccounts() {
    return request({
        url: "/agg-portal/ap/sso/accounts",
        method: 'post',
    });
}

export function setPhone(phone, authCode) {
    return request({
        url: "/agg-portal/ap/sso/setPhone",
        method: 'post',
        params:{
            phone:phone,
            authCode:authCode
        }

    });
}

export function inquireUserPhone() {
    return request({
        url: "/agg-portal/ap/sso/inquireUserPhone",
        method: 'post',
    });
}

export function updatePassword(data) {
    return request({
        url: "/agg-portal/ap/sso/updatePassword1",
        method: 'post',
        params: data
    })
}

